/*
*
* File JS componente Archive Filters
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './archive-filters.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const archiveFilters = () => {

    let archiveFilterBlock = document.querySelector('.archive-filters');
    let textInputFilter = document.querySelector('.archive-filters .search-text input');
    let btnFilters = document.querySelector('.archive-filters__cta a');
    let allSelectFilters = document.querySelectorAll('.archive-filters__select');

    if (!archiveFilterBlock) return;

    const applyFilters = () => {
        let destUrl = '';
        let yearUrl = '';
        let categoryUrl = '';
        let channelUrl = '';
        let textUrl = '';
        let awardsUrl = '';

        allSelectFilters.forEach(el => {
            
            if (el.value == '-1') return;

            switch (el.name) {
                case 'year':
                    yearUrl += `/${el.value}`;
                    break;
                case 'category':
                    categoryUrl += `/${el.value}`;
                    break;
                case 'channel':
                    channelUrl += `channel=${el.value}`;
                    break;
                case 'select-award':
                    awardsUrl += `aw=${el.value}`;
                    break;
            }
        });

        if (textInputFilter.value !== '')
        {
            if (channelUrl !== '' || awardsUrl !== '')
            {
                textUrl += '&';
            }
            else
            {
                textUrl += '?';
            }

            textUrl += `text=${textInputFilter.value}`;
        }

        // Gestione "?" o "&" per anno e channel
        if (channelUrl !== '')
        {
            channelUrl = '?' + channelUrl;
        }
        
        if (awardsUrl !== '')
        {
            if (channelUrl !== '')
            {
                awardsUrl = '&' + awardsUrl;
            }
            else
            {
                awardsUrl = '?' + awardsUrl;
            }
        }
        // ----- //

        destUrl = categoryUrl + yearUrl + channelUrl + awardsUrl + textUrl;

        if (destUrl !== '') 
        {
            window.location = immediaData.path_page_filters  + destUrl;
        }
        else
        {
            window.location = immediaData.path_page_filters;
        }
        return false;
    }
    
    btnFilters.addEventListener('click', (evt) => 
    {
        evt.preventDefault();

        applyFilters();
    });

    document.addEventListener('keyup', (evt) => {
        evt.preventDefault();

        if(evt.keyCode !== 13) return;
        
        applyFilters();
    });
}

export default archiveFilters;

//--------------------------------------------------------------------//